import UA from '../utils/ua';

let iosSend = data => {
    if(!window.prompt) return {};
    // window.webkit.messageHandlers.jsCallNative.postMessage(
    //     JSON.stringify(data)
    // );
    // console.info('data'+JSON.stringify(data))
    // console.info('return'+JSON.stringify(prompt(JSON.stringify(data))))
    return prompt(JSON.stringify(data));
};

let windowSend = (data) => {
    if(!window.prompt) return {};
    return prompt(JSON.stringify(data));
    // window.bridge.postMessage(JSON.stringify(data));
};

let androidSend = data => {
    if (!window.JsToAndroid) {
        return {};
    }
    // window.JsToAndroid.postMessage(JSON.stringify(data));
    return window.JsToAndroid.prompt(JSON.stringify(data));
};

const createNewTask = (tag, params = {}) => {
    console.log('params', {
        msgTag: tag,
        ...params
    });
    const data = { msgTag: tag, ...params };
    if(UA.iosClient)return iosSend(data);
    else if(UA.androidClient || UA.androidTabClient) return androidSend(data);
    else if(UA.winClient) return windowSend(data);
    // else return windowSend(data);

};

export default createNewTask;



// WEBPACK FOOTER //
// ./src/api/request.js